import { useState } from 'react';
import { api } from '../lib/api.ts';
import { baht, thaiDate, todayLocal } from '../lib/format.ts';
import { openDrawer } from '../actions.ts';
import { useStore } from '../store.tsx';
import { Alert, AsyncButton, Field, NumPad, padToSatang, useToast } from '../ui.tsx';

/**
 * เปิดรอบลิ้นชักประจำวัน
 *
 * ★ หนึ่งวันมีได้รอบเดียวต่อสาขา ★ บังคับด้วย UNIQUE ในฐานข้อมูล
 * ไม่ได้พึ่งให้หน้าจอจำ — สองเครื่องในสาขาเดียวกันกดเปิดพร้อมกัน
 * เครื่องที่สองจะได้ข้อความบอกว่าเปิดไปแล้ว ไม่ใช่ได้รอบซ้อน
 *
 * วันทำการมาจากที่พนักงานเลือก ไม่ใช่จากนาฬิกา — ร้านปิดดึกข้ามเที่ยงคืน
 * แล้วยังถือเป็นยอดของวันเดิม ซึ่งเป็นบั๊กวันเลื่อนของระบบเดิม
 */
export function OpenDrawerScreen() {
  const store = useStore();
  const toast = useToast();
  const [businessDate, setBusinessDate] = useState(todayLocal());
  const [float, setFloat] = useState('');
  const [note, setNote] = useState('');
  const [error, setError] = useState<string | null>(null);

  const floatSatang = padToSatang(float) ?? 0;

  const open = async () => {
    setError(null);
    try {
      await api.post('/drawer-sessions', {
        branchId: store.branch.id,
        businessDate,
        openingFloatSatang: floatSatang,
        note,
      });
      // ใส่เงินทอนเข้าลิ้นชักตอนเช้า จึงต้องเปิดลิ้นชักจริง
      const problem = await openDrawer(store, true, 'drawer_session_open');
      if (problem) toast(problem, 'warn');
      await store.reloadDrawer();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'เปิดรอบไม่สำเร็จ');
    }
  };

  return (
    <div className="page" style={{ maxWidth: 560 }}>
      <h1>เปิดรอบลิ้นชัก</h1>
      <p className="lede">
        {store.branch.name} · ยังไม่ได้เปิดรอบของวันนี้ เปิดก่อนถึงจะเริ่มขายได้
      </p>

      {error && <Alert>{error}</Alert>}

      <Field label="วันทำการ">
        <input
          type="date"
          value={businessDate}
          onChange={(e) => setBusinessDate(e.target.value)}
        />
        <div className="sub" style={{ marginTop: 6, color: 'var(--ink-3)', fontSize: '.88rem' }}>
          {thaiDate(businessDate)} — ถ้าขายข้ามเที่ยงคืน ให้คงวันที่เปิดร้านไว้
        </div>
      </Field>

      <Field label="เงินทอนที่ใส่ไว้ในลิ้นชัก (บาท)">
        <div className="amount-display">{baht(floatSatang)}</div>
        <NumPad onChange={setFloat} />
      </Field>

      <Field label="หมายเหตุ">
        <input
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="ไม่บังคับ"
        />
      </Field>

      <AsyncButton className="btn big wide" onClick={open}>
        เปิดรอบและเริ่มขาย
      </AsyncButton>
    </div>
  );
}
